import { render, staticRenderFns } from "./EventPageTitle.vue?vue&type=template&id=1ddc4519&scoped=true&"
import script from "./EventPageTitle.vue?vue&type=script&lang=ts&"
export * from "./EventPageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./EventPageTitle.vue?vue&type=style&index=0&id=1ddc4519&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc4519",
  null
  
)

export default component.exports